import { render, staticRenderFns } from "./library-link.vue?vue&type=template&id=1ef7492e&scoped=true&"
import script from "./library-link.vue?vue&type=script&lang=js&"
export * from "./library-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef7492e",
  null
  
)

export default component.exports